module.exports = __webpack_public_path__ + "img/ko.bf18cb42.png";